
import React from 'react';
import { cn } from '@/lib/utils';

interface ComboAnimationProps {
  combo: number;
  x: number;
  y: number;
}

const getComboClass = (combo: number) => {
  if (combo >= 20) return "text-orange-500 animate-bounce";  // Legendary bounce effect
  if (combo >= 15) return "text-pink-500 animate-pulse";     // Epic pulse effect
  if (combo >= 10) return "text-accent animate-fade-in";     // Rare fade effect
  if (combo >= 8) return "text-secondary";                   // Uncommon
  if (combo >= 5) return "text-primary";                     // Common
  return "";                                                 // Basic
};

const getComboText = (combo: number) => {
  if (combo >= 20) return `${combo}x LEGENDARY!`;
  if (combo >= 15) return `${combo}x EPIC!`;
  if (combo >= 10) return `${combo}x AWESOME!`;
  if (combo >= 8) return `${combo}x GREAT!`;
  if (combo >= 5) return `${combo}x NICE!`;
  return `${combo}x COMBO!`;
};

const ComboAnimation = ({ combo, x, y }: ComboAnimationProps) => {
  if (combo === 0) return null;

  return (
    <div 
      className={cn(
        "absolute px-2 py-1 rounded-full text-xs font-bold z-20",
        "bg-black/50 backdrop-blur-sm transition-all duration-200",
        getComboClass(combo)
      )}
      style={{
        left: `${x}px`,
        top: `${y}px`,
        transform: 'translate(8px, -24px)',
        pointerEvents: 'none',
      }}
    >
      {getComboText(combo)}
    </div>
  );
};

export default ComboAnimation;
